import { render } from "./ThreeCircles.vue?vue&type=template&id=64e58f3e&scoped=true"
import script from "./ThreeCircles.vue?vue&type=script&lang=js"
export * from "./ThreeCircles.vue?vue&type=script&lang=js"

import "@/assets/css/circlestyles.css?vue&type=style&index=0&id=64e58f3e&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-64e58f3e"]])

export default __exports__